// Nhân sự đã nghỉ (QĐ 0412, CEO chốt 1a 18/10/2026): máy chủ từ chối mọi lượt
// gọi lẫn mọi lượt đăng nhập của người có hồ sơ "đã nghỉ", mã `staff_inactive`.
// App xoá phiên ngay và trang đăng nhập hiện đúng câu máy chủ nói — vẽ tiếp app
// là mười khối báo lỗi mà người dùng không hiểu vì sao.
import { serverErrorCode, serverErrorMessage } from "@/lib/api/error-message";
import { useAuthV2 } from "./store";

export const STAFF_INACTIVE_CODE = "staff_inactive";

const FALLBACK = "Tài khoản này thuộc nhân sự đã nghỉ việc — liên hệ phòng nhân sự";

/**
 * Lượt gọi nghiệp vụ bị 403 mang mã đã nghỉ thì đăng xuất ngay. Đọc thân bằng
 * bản sao nên màn gọi vẫn đọc được lời từ chối như mọi 403 khác.
 */
export async function signOutIfStaffInactive(res: Response): Promise<void> {
  if (res.status !== 403) return;
  let body: unknown;
  try {
    body = await res.clone().json();
  } catch {
    // Không phải phong bì lỗi của máy chủ (trang lỗi của proxy…): không phải
    // lời từ chối của cổng đã nghỉ.
    return;
  }
  if (serverErrorCode(body) !== STAFF_INACTIVE_CODE) return;
  useAuthV2.getState().signOut(serverErrorMessage(body, FALLBACK));
}
